import { create } from "zustand";
import type { PasswordChangeVariant } from "@/components/designSystem/PasswordChangeModal";

interface PasswordChangeState {
  open: boolean;
  /** first-login: 임시 비밀번호 강제 변경(닫기 불가) / change: 단순 변경(닫기 가능) */
  variant: PasswordChangeVariant;
  openModal: (variant: PasswordChangeVariant) => void;
  closeModal: () => void;
}

/**
 * 비밀번호 변경 모달 전역 상태.
 * - 사이드바 프로필 메뉴 → openModal("change")
 * - 최초 로그인(임시 비밀번호) → openModal("first-login")
 * 모달 자체는 MainLayout 에 한 번만 렌더링된다.
 */
export const usePasswordChangeStore = create<PasswordChangeState>((set) => ({
  open: false,
  variant: "change",
  openModal: (variant) => set({ open: true, variant }),
  closeModal: () => set({ open: false }),
}));
